import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

/** Changes the requested time and its group limit together without discarding players. */
export const setRequestedTimeAtom = atom(
  null,
  (
    get,
    set,
    times: { requestedTime: string; minTime: string; maxTime: string }
  ) => {
    const data = get(BookingWizardDataAtom);
    if (data?.type === "RequestBooking") {
      set(BookingWizardDataAtom, {
        ...data,
        ...times,
        maxRequestGroupCount:
          data.requestGroupLimitsByTime?.[times.requestedTime] ?? 1,
      });
    } else if (data?.type === "LessonBooking") {
      set(BookingWizardDataAtom, { ...data, ...times });
    }
  }
);
